import { useContext, useState, useEffect } from 'react'
import { PassContext } from "../../pass-context"
import dataSelector from '../data-selector'

const GoogleLogo = () => {

  const { classData, objectData, instanceData, scannerInstanceData, passType } = useContext(PassContext)

  const [imageSrc, setImageSrc] = useState(null)
  
  let logoUrl = getLogoImage({ classData, objectData, instanceData, scannerInstanceData, passType })

  useEffect(() => {
    if (!logoUrl) return
    
    const img = new Image()
    img.crossOrigin = "anonymous"          // important for canvas/color picking
    img.onload = () => {
      setImageSrc(logoUrl)
    }
    img.onerror = () => setImageSrc(null)
    img.src = logoUrl                   // set after crossOrigin
  }, [logoUrl])


  return <img src={imageSrc} className="logo" crossOrigin="anonymous" />
}

export default GoogleLogo

const getLogoImage = ({ classData, objectData, instanceData, scannerInstanceData, passType }) => {
  try {

    switch (passType) {
      case "generic": return dataSelector({ objectData, instanceData, scannerInstanceData, path: "logo.sourceUri.uri" })
      case "flight": return classData.flightHeader?.carrier?.airlineLogo?.sourceUri?.uri
      // Google allows transit in class data but we are only going to support object data
      case "transit": return dataSelector({ objectData, instanceData, scannerInstanceData, path: "logo.sourceUri.uri" })
      case "eventTicket": return classData.logo?.sourceUri?.uri
      case "giftCard": return classData.programLogo?.sourceUri?.uri
      case "loyalty":return classData.programLogo?.sourceUri?.uri
      case "offer": return  classData.titleImage?.sourceUri?.uri
    }
  }
  catch (err) {
    console.error("Error destructuring logo path")
  }
}